export default "__VITE_ASSET__BTuh095Q__"